import * as PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import TextAreaField from '../../FormLegacy/FormFieldsV2/TextAreaField'
import TextField from '../../FormLegacy/FormFieldsV2/TextField'

const ReservationNoteForm = ({ name, description, onNameChange, onDescriptionChange }) => {
  const { t } = useTranslation(['reservations'])
  return (
    <div className="reservation-note-form">
      <div className="reservation-note-form__input-label">
        {t('reservations:reservationNoteForm.noteName')}
      </div>
      <TextField
        maxLength="100"
        name="note-name"
        placeholder={t('reservations:reservationNoteForm.enterNoteNamePlaceholder')}
        value={name}
        onChange={({ target: { value } }) => onNameChange(value)}
      />
      <div className="reservation-note-form__input-label">
        {t('reservations:reservationNoteForm.noteDescription')}
      </div>
      <TextAreaField
        rows={5}
        name="note-description"
        maxLength="500"
        placeholder={t('reservations:reservationNoteForm.notesPlaceholder')}
        value={description}
        onChange={({ target: { value } }) => onDescriptionChange(value)}
      />
    </div>
  )
}

ReservationNoteForm.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  onNameChange: PropTypes.func,
  onDescriptionChange: PropTypes.func,
}

export default ReservationNoteForm
